<lms-modal #modalDateSelector size="small">
  <div class="gl-popup__title">
    {{ 'tasks.licenses.extendStudents' | translate }}
  </div>

  <div
    class="gl-popup__text margin-bottom"
    [innerHtml]="'tasks.licenses.' + modalLabel | translate : { numStudents: students }"
  ></div>

  <lms-dynamic-form
    [action]="options?.action"
    [questions]="questions"
    (submit)="onSubmit($event)"
    [options]="{ showSpinnerUponSubmitting: false, buttonsBarClass: 'flex-center align-center', disableCard: true }"
  >
    <gl-button
      color-secondary
      [text]="'actions.cancel' | translate"
      (onClick)="closeModalDateSelector()"
      form-actions-before
    >
    </gl-button>
  </lms-dynamic-form>

  <div class="gl-popup__close" (click)="closeModalDateSelector()">
    <span class="glicon-close"></span>
  </div>
</lms-modal>
